import { createIcon } from './utils/createIcon.js';

export default createIcon({
  paths: [
    'M3.01 2.05v16.42c0 .28.22.5.5.5s.5-.22.5-.5v-8.06c2.31-.81 4.67-.32 6.94.16 1.36.29 2.67.56 3.93.56.97 0 1.91-.17 2.82-.62 0 0 .15-.08.23-.2s.08-.26.08-.26v-8s0-.28-.22-.43c-.21-.14-.51-.02-.51-.02-1.77.91-3.88.46-6.12-.01-2.41-.51-5.14-1.09-7.84 0 0 0-.14.05-.23.18s-.08.28-.08.28zm8.15 7.54c-2.2-.47-4.68-.98-7.15-.23V2.41c2.31-.81 4.67-.33 6.94.16 1.36.29 2.67.56 3.93.56.73 0 1.44-.09 2.13-.33v6.91c-1.71.74-3.72.33-5.85-.12z',
  ],
  height: 20,
  width: 20,
});
